import { Grid as Grid } from "@mui/material";
import { useGet } from "../../actprep-ui/hooks/api";
import { apiUrls } from "../../actprep-ui/utils/urls";
import MasterSheetTeamCard from "./MasterSheetTeamCard";

import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  Paper,
  Divider,
  Box,
  Skeleton,
} from "@mui/material";

export function MasterSheetTeamCardSkeleton() {
  return (
    <Card
      sx={{
        width: "100%",
        boxShadow: 3,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardHeader
        avatar={<Skeleton variant="circular" width={56} height={56} />}
        title={<Skeleton variant="text" width="60%" height={30} />}
        subheader={<Skeleton variant="text" width="40%" />}
        sx={{ backgroundColor: "primary" }}
      />
      <CardContent
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* General Stats Grid */}
        <Box sx={{ mb: 3 }}>
          <Grid container spacing={2}>
            {Array.from(new Array(8)).map((_, index) => (
              <Grid key={index} size={{ xs: 4, sm: 3 }}>
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    height: "100%",
                    borderRadius: 2,
                    backgroundColor: "background.primary",
                    textAlign: "center",
                  }}
                >
                  <Skeleton
                    variant="text"
                    width="80%"
                    height={30}
                    sx={{ mx: "auto", mb: 1 }}
                  />
                  <Skeleton
                    variant="text"
                    width="40%"
                    height={20}
                    sx={{ mx: "auto" }}
                  />
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Final Coaching Score Section */}
        <Box sx={{ mt: "auto" }}>
          <Divider sx={{ mb: 3 }} />
          <Paper
            elevation={4}
            sx={{
              p: 3,
              borderRadius: 2,
              textAlign: "center",
              background: "linear-gradient(45deg, #F44336, #EF5350)",
              color: "#fff",
            }}
          >
            <Skeleton
              variant="text"
              width="40%"
              height={20}
              sx={{ mx: "auto", mb: 1 }}
            />
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={1}
              sx={{ mt: 1 }}
            >
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="text" width="30%" height={40} />
            </Stack>
            <Skeleton
              variant="text"
              width="50%"
              height={20}
              sx={{ mx: "auto", mt: 1 }}
            />
          </Paper>
        </Box>
      </CardContent>
    </Card>
  );
}

export default function MasterSheet({ filters }) {
  const coachingLayer = filters?.coaching_layer;
  const startDate = filters?.start_date;
  const { data, isLoading } = useGet(
    apiUrls.admin.masterV2Layer(coachingLayer || "assistant"),
    {
    params: {
      start_date: startDate,
    },
    enabled: Boolean(coachingLayer),
    retry: false,
  }
  );
  const teams = data?.data || [];

  return (
    <Grid container spacing={1} sx={{ width: "100%" }}>
      {isLoading ? (
        <>
          <Grid
            size={{
              xs: 12,
              md: 6,
              xl: 4,
            }}
          >
            <MasterSheetTeamCardSkeleton />
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              xl: 4,
            }}
          >
            <MasterSheetTeamCardSkeleton />
          </Grid>
        </>
      ) : (
        teams.map((team, i) => (
          <Grid
            size={{
              xs: 12,
              md: 6,
              xl: 4,
            }}
            key={i}
          >
            <MasterSheetTeamCard team={team} />
          </Grid>
        ))
      )}
    </Grid>
  );
}
